import { $isQuoteNode } from "@lexical/rich-text";
const LexicalQuoteVisitor = {
  testLexicalNode: $isQuoteNode,
  visitLexicalNode: ({ actions }) => {
    actions.addAndStepInto("blockquote");
  }
};
export {
  LexicalQuoteVisitor
};
